class MouseManager {
  constructor(initiator) {
    this.initiator = initiator;
    this.pressed = false;

    this.mouseDownHandler = (event) => { this.down(event); };
    this.mouseUpHandler = (event) => { this.up(event); };
    this.mouseMoveHandler = (event) => { this.move(event); };
  }

  addEvents() {
    this.initiator.DOMElement.addEventListener('mousedown', this.mouseDownHandler);
    this.initiator.DOMElement.addEventListener('mouseup', this.mouseUpHandler);
    this.initiator.DOMElement.addEventListener('mousemove', this.mouseMoveHandler);
  }

  removeEvents() {
    this.initiator.DOMElement.removeEventListener('mousedown', this.mouseDownHandler);
    this.initiator.DOMElement.removeEventListener('mouseup', this.mouseUpHandler);
    this.initiator.DOMElement.removeEventListener('mousemove', this.mouseMoveHandler);
  }

  down() {
    this.pressed = true;
  }

  up() {
    this.pressed = false;
  }

  move(event) {
    if (!this.pressed) return;
    this.initiator.point = {
      x: event.clientX - this.initiator.DOMRect.left,
      y: event.clientY - this.initiator.DOMRect.top,
    };
  }
}

export default MouseManager;
